/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import { padding } from 'polished';

type Props = {
  children: any,
  title: string,
  warn?: boolean,
};

const Block = glamorous.div(({ theme }) => ({
  ...padding(null, theme.spacing.small),
  position: 'relative',
  lineHeight: 1,
}));

const Title = glamorous.div(({ theme }) => ({
  color: theme.color.basis5,
  fontSize: theme.fontSize.tiny,
  paddingBottom: theme.spacing.xsmall,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
}));

const Data = glamorous.div(({ theme, warn }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  fontSize: theme.fontSize.default,
  color: warn ? theme.color.danger : 'inherit',
  fontWeight: warn ? theme.fontWeight.demiBold : 'inherit',
}));

function SalaryStatusBlock({ children, title, warn }: Props) {
  return (
    <Block>
      <Title>{title}</Title>
      <Data warn={warn}>{children}</Data>
    </Block>
  );
}

SalaryStatusBlock.defaultProps = {
  warn: false,
};

export default SalaryStatusBlock;
